import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import HearingService from '../../../../services/HearingService';
const DetailsForm = require('./detailsform/detailsform.vue.html');

export interface ContactsData {
    internalContacts: Object
    employerContacts: Object
}

@Component({
    components: {
        DetailsForm
    }
})
export default class HearingDetails extends Vue {
    @Prop({ required: true, type: Number }) id!: 0;
    //@Prop({ type: Boolean }) editable!: false;

    hearingDetails: object = {};

    public service = new HearingService();

    loadHearingDetails() {
        this.service.GetHearingDetails(this.id, this.$store.state.user.userName)
            .then((resp) => {
                if (resp) {
                    this.hearingDetails = resp;
                    this.$set(this.hearingDetails, 'UserID', this.$store.state.user.userName);
                }

                this.$store.dispatch("isLoading", false);
            })
    }
    mounted() {
        console.log('mounting the hearing details for: ' + this.id);
        this.loadHearingDetails();
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/hearingdetails.ts